import type { FaireProductEntity } from "../../entity_types/product";

export const p_5c3fsyqn6k: FaireProductEntity = {
  token: "p_5c3fsyqn6k",
  type: "product",
  name: "Kolbies | Seaglass",
  brandToken: "b_gycan7rcyq",
  brandName: "Clay by Shay",
  imageUrl:
    "https://cdn.faire.com/fastly/023d9415de68030a9b513afabb180d74bb1544620a760305e6b111c0ea3d78de.jpeg",
  galleryImageUrls: [],
  priceDollars: 23,
  description:
    "The Kolbie, like a moon on the horizon, simple and stunning.\n\n• Handmade by 2 creative women in Boise, Idaho\n• Your choice of 14k gold or sterling silver\n• Kiln fired\n• Plastic/polymer-free\n• Waterproof\n• 1.25 in.",
  tags: [],
  msrpDollars: 46,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:28.269Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
